module.exports = __webpack_public_path__ + "static/media/calendar.5938e99f.webp";